<script lang="ts">
	import {ASSET_URL} from "../../config";
	import {getContext} from "svelte";

	export let title: string;
	export let message: string;
	export let onClose: () => void;

	const { close } = getContext('simple-modal');

	function closeMe() {
		close();
		onClose?.();
    }
</script>

<div class="modal" tabindex="-1" style="display: block;" aria-modal="true" role="dialog">
    <div class="modal-header">
        <div class="modal-title">
            {title}
        </div>
        <button type="button" class="modal-close" on:click={closeMe}>
            <img alt="close" src="{ASSET_URL}/assets/close.svg">
        </button>
    </div>
    <div class="modal-body">
        <p>{message}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="modal-button"
                on:click={closeMe}>
            ok
        </button>
    </div>
</div>

<style lang="scss">
  .modal {
    background: #FFFFFF;
    border-radius: 16px;

    padding: 50px;

    /* 600px, 900px, 1200px, and 1800px */
    @media (max-width: 600px) {
      padding: 20px;
    }

    .modal-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 25px;

      .modal-title {
        font-family: 'Open Sans', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 36px;
        color: #000000;
      }
      .modal-close {
        all: unset;
        cursor: pointer;
        margin: auto 0;

        line-height: 0;

        img {
          margin-bottom: 0;
          min-width: 20px;
          min-height: 20px;
        }
      }
    }

    .modal-body {
      margin-bottom: 80px;
      /* 600px, 900px, 1200px, and 1800px */
      @media (max-width: 600px) {
        margin-bottom: 30px;
      }
    }

    .modal-footer {
      display: flex;
      justify-content: end;

      .modal-button {
        all: unset;
        cursor: pointer;

        background: #F8B92C;
        border-radius: 9px !important;
        font-family: 'Open Sans', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 17px;
        line-height: 23px;
        padding: 10px 85px;

        /* 600px, 900px, 1200px, and 1800px */
        @media (max-width: 600px) {
          padding: 10px 20px;
        }

        &:hover {
         // background: darken(#F8B92C, 10%); //deprecated
          background: mix(black, #F8B92C, 10%); // Darkens the color by 10%
        }
      }
    }
  }

</style>
